export default __webpack_public_path__ + "static/media/wP.f6f89529.svg";